<template>
  <b-card-code v-if="$checkPermission($options.name, 'view')" id="tech-service-all" no-body>

    <template v-if="edit">
      <Form/>
    </template>

    <template v-else-if="docs.classificator">
      <Classificator/>
    </template>

    <template v-else-if="docs.fuel">
      <Fuel/>
    </template>

    <template v-else-if="docs.info">
      <Info/>
    </template>

    <template v-else-if="docs.reportView">
      <ReportView/>
    </template>

    <template v-else-if="docs.financial">
      <Financial/>
    </template>

    <template v-else>
      <b-row class="pageContent">
        <b-col class="filtersContainer" md="12">
          <div class="filters">

            <div v-if="!$device.isMobile" class="filter-column">
              <v-select
                  @input="changeCompany"
                  placeholder="Որոնում"
                  id="vue-select-type"
                  :reduce="prefix => prefix.id"
                  v-model="filters.type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="search_filters"
                  class="searchTypeSelect"
                  :clearable="false"
              />

            </div>

            <div v-if="$device.isMobile" class="filter-column">
              <b-dropdown
                  size="sm"
                  text=""
                  variant="flat-primary"
                  id="docs_selector"
              >
                <b-dropdown-item @click="changeSearchTypeMobile(item.id)" v-for="item in search_filters">
                  {{item.label}}
                </b-dropdown-item>

              </b-dropdown>
            </div>

            <div class="filter-column" :style="$device.isMobile ? 'width: 150px;' : ''">
              <b-form-input
                  :style="$device.isMobile ? 'min-width: initial !important;' : ''"
                  autocomplete="new_owner_name"
                  @change="searchCheckup"
                  @keydown="disableSymbol($event)"
                  v-model="filters.search"
                  id="owner_name"
                  type="text"
                  placeholder="Փնտրել..."
                  class="w-full text-uppercase opinionFilter"
                  clearable
              />
            </div>

            <div v-if="!$device.isMobile" class="filter-column">
              <v-select
                  @input="changeCompany"
                  placeholder="Կազմակերպություն"
                  id="vue-select"
                  :reduce="prefix => prefix.id"
                  v-model="filters.company"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="companies"
                  class="companyFilterSelect"
              />
            </div>

            <div v-else>
              <select placeholder="Կազմակերպություն" style="height: 38px; border: 1px solid #ccc; width: 150px; margin-right: 5px;" @change="changeCompany" v-model="filters.company">
                <option value="">Կազմակերպություն</option>
                <option v-for="company in companies" :value="company.id">{{ company.label }}</option>
              </select>
            </div>

            <div v-if="!$device.isMobile" class="filter-column">
              <div @click="getRemovedItemsIncluded" :class="(onlyRemoved) ? 'double-checkup active' : 'double-checkup'">
                <fa-icon icon="trash-alt" />
                <sup style="position: relative; left: 6px; font-size: 15px;">+</sup>
              </div>
            </div>

            <div v-if="!$device.isMobile" class="filter-column">
              <div @click="getRemovedItemsNotIncluded" :class="(withoutRemoved) ? 'double-checkup active' : 'double-checkup'">
                <fa-icon icon="trash-alt" />
                <sup style="position: relative; left: 6px; font-size: 15px;">-</sup>
              </div>
            </div>

            <div v-if="!$device.isMobile" class="filter-column">
              <div @click="getTaxDebtItems" :class="(filters.taxDebt) ? 'double-checkup active' : 'double-checkup'">
                <fa-icon icon="dollar-sign" />
              </div>
            </div>

            <div v-if="!$device.isMobile" class="filter-column">
              <div @click="getNextChanged" :class="(filters.nextCheckupChanged) ? 'double-checkup active' : 'double-checkup'">
                <fa-icon icon="calendar-alt" />
              </div>
            </div>

            <div v-if="!$device.isMobile" class="filter-column">
              <div @click="getNotAutoDetectedItemsItems" :class="(filters.autoDetection === false) ? 'double-checkup auto-detected-checkup active' : 'double-checkup auto-detected-checkup'">
                <fa-icon icon="times" />
              </div>
            </div>

            <div v-if="!$device.isMobile" class="filter-column">
              <b-form-select
                  @change="getCheckups"
                  id="textarea"
                  v-model="filters.cameraReasonId"
                  placeholder="Ընտրեք պատճառը"
                  :options="cameraReasonOptions"
                  rows="3"
                  max-rows="6"
              ></b-form-select>
            </div>

          </div>
        </b-col>
        <b-col md="12">
          <ag-grid-vue
              @gridReady="onGridReady"
              ref="agGridTable"
              :localeText="localization"
              :components="components"
              :gridOptions="gridOptions"
              :class="table_class"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="checkups"
              rowSelection="multiple"
              colResizeDefault="shift"
              :animateRows="true"
              :floatingFilter="true"
              :pagination="true"
              :paginationPageSize="50"
              :suppressPaginationPanel="true"
              :enableRtl="$vs.rtl">
          </ag-grid-vue>
          <b-card-body class="table-footer d-flex justify-content-between flex-wrap pt-0 pb-0 align-items-center">

            <!-- page length -->
            <strong class="black">
              {{ pagination.total }} արդյունք
            </strong>

            <!-- pagination -->
            <div>
              <b-pagination
                  @input="changePage"
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.count"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </b-card-body>
        </b-col>

        <table style="display: none" id="exportTable">
          <thead>
          <tr>
            <th v-if="!isHide(column.id)" :colspan="column.children.length" v-for="column in techServiceColumns">{{column.headerName}}</th>
          </tr>
          <tr>
            <template v-for="column in techServiceColumns">
              <th v-if="!isHide(item.id)" v-for="item in column.children">{{item.headerName}}</th>
            </template>
          </tr>
          </thead>
          <tbody>
          <tr v-for="checkup of export_checkups">

            <td v-if="!isHide('001')">{{(checkup.Opinion) ? 'Ստուգված է' : 'Անսարք է'}}</td>
            <td v-if="!isHide('002')">{{checkup.createdAt | formatDate}}</td>
            <td v-if="!isHide('003')">{{checkup.car}} {{checkup.car_model}}</td>
            <td v-if="!isHide('004')">{{checkup.CarRegNo}}</td>
            <td v-if="!isHide('005')">{{checkup.documentNumber}}</td>
            <td v-if="!isHide('006')">{{checkup.CheckNo}}</td>
            <td v-if="!isHide('007')">{{checkup.body}}</td>
            <td v-if="!isHide('008')">{{checkup.color}}</td>
            <td v-if="!isHide('009')">{{nextCheckupFormatter({value: checkup.NextCheckup})}}</td>

            <td v-if="!isHide('011')">{{ (checkup.createdBy) ? checkup.createdBy.name : ''}}</td>
            <td v-if="!isHide('012')">{{checkup.company.name}}</td>
            <td v-if="!isHide('013')">{{companyAddressFormatter({value: checkup.company})}}</td>

            <td v-if="!isHide('021')">{{checkup.ownerStatus.Owner}}</td>
            <td v-if="!isHide('022')">{{checkup.ownerStatus.Notes}}</td>
<!--            <td v-if="!isHide('023')">{{checkup.Phone}}</td>-->
            <td v-if="!isHide('024')">{{checkup.region}}</td>
            <td v-if="!isHide('025')">{{checkup.county}}</td>
            <td v-if="!isHide('026')">{{checkup.street}}</td>
            <td v-if="!isHide('027')">{{checkup.address}}</td>
            <td v-if="!isHide('028')">{{checkup.documentNumber}}</td>

            <td v-if="!isHide('031')">{{checkup.car_group}}</td>
            <td v-if="!isHide('032')">{{checkup.car_type}}</td>
            <td v-if="!isHide('033')">{{checkup.car}} {{checkup.car_model}}</td>
            <td v-if="!isHide('034')">{{checkup.car}}</td>
            <td v-if="!isHide('035')">{{checkup.car_model}}</td>
            <td v-if="!isHide('036')">{{checkup.MadeAt}}</td>
            <td v-if="!isHide('037')">{{checkup.CarRegNo}}</td>
            <td v-if="!isHide('038')">{{checkup.fuel}}</td>
            <td v-if="!isHide('039')">{{checkup.body}}</td>
            <td v-if="!isHide('0391')">{{checkup.color}}</td>
            <td v-if="!isHide('0392')">{{checkup.VIN}}</td>
            <td v-if="!isHide('0393')">{{checkup.EngineNo}}</td>
            <td v-if="!isHide('0394')">{{checkup.TrilerNo}}</td>
            <td v-if="!isHide('0395')">{{checkup.BodyNo}}</td>
            <td v-if="!isHide('0396')">{{checkup.GasNo}}</td>
            <td v-if="!isHide('0397')">{{checkup.GasDate | formatDay}}</td>

            <td v-if="!isHide('041')">{{ (checkup.Changes) ? 'Առկա է' : 'Առկա չէ'}}</td>
            <td v-if="!isHide('042')">{{checkup.ChangesNotes}}</td>

            <td v-if="!isHide('051')">{{checkup.CheckNo}}</td>
            <td v-if="!isHide('052')">{{checkup.CheckNotes}}</td>
            <td v-if="!isHide('053')">{{checkup.EkoDate | formatDay}}</td>
            <td v-if="!isHide('054')">{{(checkup.Opinion) ? 'Սարքին է' : 'Անսարք է'}}</td>
            <td v-if="!isHide('055')">{{checkup.OpinionNotes}}</td>
            <td v-if="!isHide('056')">{{nextCheckupFormatter({value: checkups.NextCheckup})}}</td>
            <td v-if="!isHide('057')">{{(checkup.DoubleChecked) ? 'Այո' : 'Ոչ' }}</td>

            <td v-if="!isHide('061')">{{checkup.EkoNo}}</td>
            <td v-if="!isHide('062')">{{checkup.EkoSum}}</td>
            <td v-if="!isHide('063')">{{checkup.Sum}}</td>
          </tr>
          </tbody>
        </table>
      </b-row>
    </template>

    <b-modal
        id="modal-add-c1-number"
        :no-close-on-backdrop="true"
        centered
        size="sm"
        title="Կտրոնի կրկնօրինակ"
        :is-valid="false"
    >

      <b-form>
        <b-form-group>

          <div class="position-relative table-responsive">
            <table role="table" aria-busy="false" aria-colcount="7" class="table b-table table-striped table-hover"
                   id="__BVID__139"><!----><!---->
              <thead role="rowgroup" class=""><!---->
              <tr role="row" class="">
                <th role="columnheader" scope="col" aria-colindex="2" class="">
                  <div>Ամսաթիվ</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Կտրոնի համար</div>
                </th>
              </tr>
              </thead>
              <tbody role="rowgroup"><!---->

              <tr v-for="num in checkupNumbers" role="row" class="">
                <td aria-colindex="6" role="cell" class="">{{ num.createdAt | formatDate }}</td>
                <td aria-colindex="7" role="cell" class=""> {{ num.number }}</td>
              </tr>
              </tbody>
            </table>
          </div>


        </b-form-group>
      </b-form>


      <template #modal-footer="{ ok, cancel, hide }">
        <span variant="info">&nbsp;</span>
      </template>


    </b-modal>

    <b-modal
        id="modal-checkup-company-info"
        centered
        title="Կազմակերպություն"
        :is-valid="false"
    >

      <div v-if="companyInfo" class="companyInfo">
        <div class="infoItem">
          <div class="label">Կազմակերպություն:</div>
          <div class="value">{{companyInfo.company.name}}</div>
        </div>
        <div class="infoItem">
          <div class="label">Կազմակերպության հասցե:</div>
          <div class="value">{{companyInfo.company.region}} {{companyInfo.company.county}} {{companyInfo.company.street}} {{companyInfo.company.address}}</div>
        </div>
        <div class="infoItem">
          <div class="label">Մեքենա:</div>
          <div class="value">{{companyInfo.car}} {{companyInfo.car_model}}</div>
        </div>
        <div class="infoItem">
          <div class="label">Կտրոնի համար:</div>
          <div class="value">{{ (companyInfo.CheckNo) ? companyInfo.companyInfo : '-' }}</div>
        </div>
        <div class="infoItem">
          <div class="label">Տնօրինող:</div>
          <div class="value">{{companyInfo.ownerStatus.Owner}}</div>
        </div>
        <div class="infoItem">
          <div class="label">Հասցե:</div>
          <div class="value">{{companyInfo.region}} {{companyInfo.county}} {{companyInfo.street}} {{companyInfo.address}}</div>
        </div>
        <div class="infoItem">
          <div class="label">Համարանիշ:</div>
          <div class="value">{{companyInfo.CarRegNo}} {{ (companyInfo.YellowCarRegNo) ? `(${companyInfo.YellowCarRegNo})` : ''}}</div>
        </div>
        <div class="infoItem">
          <div class="label">Փաստաթուղթ:</div>
          <div class="value">{{companyInfo.documentNumber}}</div>
        </div>
        <div class="infoItem">
          <div class="label">Նույնականացման VIN կոդ:</div>
          <div class="value">{{companyInfo.VIN}}</div>
        </div>
        <div class="infoItem">
          <div class="label">Հաջորդ ՏԶ:</div>
          <div class="value">{{nextCheckupName(companyInfo.NextCheckup)}}</div>
        </div>
        <div class="infoItem">
          <div class="label">Թափքի տեսակ:</div>
          <div class="value">{{companyInfo.body}}</div>
        </div>
<!--        <div class="infoItem">-->
<!--          <div class="label">Գույն:</div>-->
<!--          <div class="value">{{companyInfo.color}}</div>-->
<!--        </div>-->
        <div class="infoItem">
          <div class="label">Եզրակացություն:</div>
          <div class="value">{{ (companyInfo.Opinion) ? 'Սարքին է' : 'Անսարք է' }}</div>
        </div>
        <div class="infoItem">
          <div class="label">Կրկնակի Տ․Զ․:</div>
          <div class="value">{{ (companyInfo.DoubleChecked) ? 'Այո' : 'Ոչ' }}</div>
        </div>
      </div>


      <template #modal-footer="{ ok, cancel, hide }">
        <span variant="info">&nbsp;</span>
      </template>


    </b-modal>

    <b-modal
        id="modal-checkup-history"
        :no-close-on-backdrop="true"
        centered
        size="lg"
        class="modal-responsive"
        title="Պատմություն"
        :is-valid="false"
    >

      <b-form>
        <b-form-group>

          <div class="position-relative table-responsive">
            <table role="table" aria-busy="false" aria-colcount="7" class="table mb-2 b-table table-striped table-hover"
                   id="__BVID__140"><!----><!---->
              <thead role="rowgroup" class=""><!---->
              <tr role="row" class="">
                <th role="columnheader" scope="col" aria-colindex="2" class="">
                  <div>Ամսաթիվ</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Մոդերատոր</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Գործողույուն</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Նախկին տվյալ</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Նոր տվյալ</div>
                </th>
              </tr>
              </thead>
              <tbody role="rowgroup"><!---->

              <tr v-for="history in checkupHistory" role="row" class="">
                <td aria-colindex="6" role="cell" class="">{{ history.createdAt | formatDate }}</td>
                <td aria-colindex="7" role="cell" class=""> {{ (history.user) ? history.user.name : '' }}</td>
                <td aria-colindex="7" role="cell" class=""> {{ history.note }}</td>
                <td aria-colindex="7" role="cell" class=""> {{ history.old }}</td>
                <td aria-colindex="7" role="cell" class=""> {{ history.new }}</td>
              </tr>
              </tbody>
            </table>
          </div>


        </b-form-group>
      </b-form>


      <template #modal-footer="{ ok, cancel, hide }">
        <span variant="info">&nbsp;</span>
      </template>


    </b-modal>

    <b-modal
        id="modal-checkup-history-classificators"
        :no-close-on-backdrop="true"
        centered
        size="xl"
        class="modal-responsive"
        title="Պատմություն"
        :is-valid="false"
    >

      <b-form>
        <b-form-group>

          <div class="position-relative table-responsive">
            <table role="table" aria-busy="false" aria-colcount="7" class="table mb-2 b-table table-striped table-hover"
                   id="__BVID__140"><!----><!---->
              <thead role="rowgroup" class=""><!---->
              <tr role="row" class="">
                <th role="columnheader" scope="col" aria-colindex="2" class="">
                  <div>Ամսաթիվ</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Մոդերատոր</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Նախկին տվյալ</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Նոր տվյալ</div>
                </th>
              </tr>
              </thead>
              <tbody role="rowgroup"><!---->

              <tr v-for="history in checkupHistory.filter(e => e.note === 'Արատորոշման քարտի խմբագրում')" role="row" class="">
                <td aria-colindex="6" role="cell" class="">{{ history.createdAt | formatDate }}</td>
                <td aria-colindex="7" role="cell" class=""> {{ (history.user) ? history.user.name : '' }}</td>
                <td aria-colindex="7" role="cell" class=""> {{ history.old }}</td>
                <td aria-colindex="7" role="cell" class=""> {{ history.new }}</td>
              </tr>
              </tbody>
            </table>
          </div>


        </b-form-group>
      </b-form>


      <template #modal-footer="{ ok, cancel, hide }">
        <span variant="info">&nbsp;</span>
      </template>


    </b-modal>

  </b-card-code>
</template>

<script>

import techServiceModule from '@/store/tech-service/techServiceModule'
import CellRendererStatus from '@/views/pages/tech-service/columns/CellRendererStatus'
import companyModule from '@/store/companies/companyModule'
import store from '@/store'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import Financial from '@/views/pages/tech-service/docs/Financial'
import {
  BAvatar,
  BBadge,
  BButton,
  BCardBody,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BRow,
  BTable,
  BAlert,
  BDropdown,
  BDropdownItem
} from 'bootstrap-vue'
import { AgGridVue } from 'ag-grid-vue'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css'
import Form from '@/views/pages/tech-service/Form'
import CellRendererOpinion from '@/views/pages/tech-service/columns/CellRendererOpinion'
import CellRendererTaxi from '@/views/pages/tech-service/columns/CellRendererTaxi'
import CellRendererChanges from '@/views/pages/tech-service/columns/CellRendererChanges'
import CellRendererCanEdit from '@/views/pages/tech-service/columns/CellRendererCanEdit'
import CellRendererEdit from '@/views/pages/tech-service/columns/CellRendererEdit'
import CellRendererAttachment from '@/views/pages/tech-service/columns/CellRendererAttachment'
import CellRendererCarRegNo from '@/views/pages/tech-service/columns/CellRendererCarRegNo'
import AG_GRID_LOCALE_HY from '@core/global/ag-grid-hy'
import vSelect from 'vue-select'
import Classificator from '@/views/pages/tech-service/docs/Classificator'
import Fuel from '@/views/pages/tech-service/docs/Fuel'
import Info from '@/views/pages/tech-service/docs/Info'
import ReportView from '@/views/pages/tech-service/docs/ReportView'
import carsModule from '@/store/cars/cars'
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import locationsModule from "@/store/locations/locations";
import authService from "@/services/authService";

export default {
  name: 'tech-service-view',

  components: {
    vSelect,
    BCardCode,
    AgGridVue,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BForm,
    BRow,
    BCol,
    BTable,
    BAlert,
    BDropdown,
    BDropdownItem,
    Form,
    CellRendererOpinion,
    CellRendererTaxi,
    CellRendererChanges,
    CellRendererCanEdit,
    CellRendererEdit,
    CellRendererAttachment,
    CellRendererCarRegNo,
    Classificator,
    Fuel,
    Info,
    ReportView,
    Financial,
    CellRendererStatus,
  },

  data() {
    return {
      onlyRemoved: false,
      withoutRemoved: true,
      TECH_SERVICE_STORE_MODULE_NAME: 'techServiceModule',
      COMPANIES_STORE_MODULE_NAME: 'companiesModule',
      CARS_STORE_MODULE_NAME: 'carsModule',
      LOCATIONS_STORE_MODULE_NAME: 'locationsModule',
      gridOptions: {
        getRowStyle: (params) => {
          if (params.data.CheckNoEdited) {
            return { 'background-color': '#ffc107' }
          }
          if (params.data.deleted) {
            return { 'background-color': '#afafaf' }
          }
          if (params.data.nextCheckupChanged) {
            return { 'background-color': '#f6ce88' }
          }
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      components: null,
      opinions: [
        {
          label: 'Սարքին',
          id: true
        },
        {
          label: 'Անսարք',
          id: false
        }
      ],
      cameraReasonOptions: [
        {
          value: null,
          text: 'Ընտրեք պատճառը'
        },
        {
          value: 'Տրանզիտ',
          text: 'Տրանզիտ'
        },
        {
          value: 'Կցորդ / կիսակցորդ',
          text: 'Կցորդ / կիսակցորդ'
        },
        {
          value: 'Մոտոցիկլ',
          text: 'Մոտոցիկլ'
        },
        {
          value: 'Սխալ ընթերցում',
          text: 'Սխալ ընթերցում'
        },
        {
          value: 'Դեղին համարանիշ',
          text: 'Դեղին համարանիշ'
        }
      ],
    }
  },

  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    let todayStart = new Date()
    todayStart.setHours(0, 0, 0, 0)

    let todayEnd = new Date()
    todayEnd.setHours(23, 59, 59, 59)

    const initialFilters = {
      Opinion: true,
      startDate: todayStart,
      endDate: todayEnd,
      search: '',
      company: '',
      fields: {}
    }

    return {
      skin,
      isDark,
      initialFilters
    }
  },

  computed: {

    regions() {
      return this.$store.state[this.LOCATIONS_STORE_MODULE_NAME].regions.map(e => ({ label: e.name, value: e.name }))
    },

    checkupHistory() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].checkupHistory
    },

    companyInfo() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].companyInfo
    },

    checkupNumbers() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].checkupNumbers
    },

    search_filters() {
      return [
        {
          label: 'Գրանցման համարանիշի',
          id: 'CarRegNo'
        },
        {
          label: 'Գրանցման փաստաթղթի',
          id: 'documentNumber'
        },
        {
          label: 'Նույնականացման VIN կոդի',
          id: 'VIN'
        },
        // {
        //   label: 'Շարժիչի համարի',
        //   id: 'EngineNo'
        // },
        // {
        //   label: 'Հենասարքի համարի',
        //   id: 'TrilerNo'
        // },
        // {
        //   label: 'Թափքի համարի',
        //   id: 'BodyNo'
        // }
      ]
    },

    techServiceColumns () {
      return this.$store.state.techServiceColumns
    },

    columnStatuses() {
      return this.$store.state.columnStatuses
    },

    isHide () {
      return (id) => {
        let index = this.columnStatuses.findIndex((e) => e.id === id)
        if (index >= 0) {
          return this.columnStatuses[index].hide
        }
        return true
      }
    },

    allowedUsers () {
      return (users) => {
        return !users.includes(this.user.email);
      }
    },

    columnDefs() {
      return [
        {
          headerName: 'Տեխզննում',
          id: '00',
          children: [
            {
              headerName: 'Կարգավիճակ',
              id: '001',
              hide: this.isHide('001'),
              field: 'createdAt',
              width: 250,
              cellRendererFramework: 'CellRendererCanEdit'
            },
            {
              headerName: 'Գույքահարկ',
              field: 'inspectionStatus',
              filter: true,
              width: 320,
              cellRendererFramework: 'CellRendererStatus'
            },
            {
              headerName: 'ԴԱՀԿ',
              field: 'dahk_exists',
              filter: true,
              width: 150,
              cellRendererFramework: 'CellRendererStatus'
            },
            {
              headerName: 'Ստեղծվել է',
              id: '002',
              hide: this.isHide('002'),
              field: 'createdAt',
              filter: true,
              floatingFilterComponent: 'customDateFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'createdAt',
                className: ''
              },
              width: 180,
              valueFormatter: this.dateFormatter
            },
            {
              headerName: 'Արատորոշում',
              id: '002',
              hide: this.filters.Opinion,
              field: 'classificators',
              width: 300,
              filter: true,
              floatingFilterComponent: 'customSelectFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'classificators',
                className: '',
                options: this.classificators,
              },
              valueFormatter: this.classificatorFormatter
            },
            {
              headerName: '📁',
              field: 'camera2',
              filter: false,
              width: 100,
              cellRendererFramework: 'CellRendererAttachment',
            },
            {
              headerName: '📷',
              field: 'camera',
              filter: false,
              width: 120,
              cellRendererFramework: 'CellRendererAttachment',
            },
            {
              headerName: 'Համարանիշ',
              id: '004',
              hide: this.isHide('004'),
              field: 'CarRegNo',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'CarRegNo',
                className: 'text-uppercase'
              },
              width: 150,
              valueFormatter: this.carRegNoFormatter,
              cellRendererFramework: 'CellRendererCarRegNo',
            },
            {
              headerName: 'Մեքենա',
              id: '003',
              hide: this.isHide('003'),
              field: 'ownerStatus.Owner',
              width: 180,
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'car',
                className: ''
              },
              valueFormatter: this.carFormatter
            },
            {
              headerName: 'Փաստաթուղթ',
              id: '005',
              hide: this.isHide('005'),
              field: 'documentNumber',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'documentNumber',
                className: 'text-uppercase'
              },
              width: 140,
              valueFormatter: this.uppercaseFormatter
            },
            {
              headerName: 'Նույնացման (VIN) համարը',
              id: '006',
              hide: this.isHide('006'),
              field: 'VIN',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'VIN',
                className: 'text-uppercase'
              },
              width: 210,
            },
            {
              headerName: 'Հաջորդ Տ․Զ․',
              id: '009',
              hide: this.isHide('009'),
              field: 'NextCheckup',
              filter: true,
              floatingFilterComponent: 'customSelectFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'NextCheckup',
                className: '',
                options: [
                  {
                    value: 0,
                    label: '6 ամսից'
                  },
                  {
                    value: 1,
                    label: '1 տարուց'
                  },
                  {
                    value: 2,
                    label: '2 տարուց'
                  }
                ]
              },
              width: 160,
              valueFormatter: this.nextCheckupFormatter
            },
            // {
            //   headerName: 'Թափքի տեսակ',
            //   field: 'body',
            //   filter: false,
            //   floatingFilterComponent: 'customFloatingFilter',
            //   floatingFilterComponentParams: {
            //     suppressFilterButton: true,
            //     field: 'body',
            //     className: ''
            //   },
            //   width: 150,
            //   valueFormatter: this.bodyNameFormatter,
            // },
            // {
            //   headerName: 'Գույն',
            //   field: 'color',
            //   filter: true,
            //   floatingFilterComponent: 'customFloatingFilter',
            //   floatingFilterComponentParams: {
            //     suppressFilterButton: true,
            //     field: 'color',
            //     className: ''
            //   },
            //   width: 180,
            // }
          ]
        },
        {
          headerName: 'Տեխնիկական զննության կայան',
          id: '01',
          children: [
            {
              headerName: 'Օպերատոր',
              id: '011',
              hide: this.isHide('011'),
              field: 'createdBy.name',
              width: 150,
              filter: true,
              floatingFilterComponent: 'customSelectFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'createdBy',
                className: '',
                options: this.company_operators
              },
            },
            {
              headerName: 'Անվանում',
              id: '012',
              hide: this.isHide('012'),
              field: 'company.name',
              width: 150,
            },
            {
              headerName: 'Տ․Զ․Կ հասցե',
              field: 'company',
              valueFormatter: this.companyAddressFormatter,
              width: 200,
              id: '013',
              hide: this.isHide('013'),
              filter: true,
              floatingFilterComponent: 'customSelectFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'company.region',
                className: '',
                options: this.regions,
              },
            },
          ]
        },
        {
          headerName: 'Տրանսպորտային միջոցի տնօրինող',
          id: '02',
          children: [
            {
              headerName: 'Տնօրինող',
              id: '021',
              hide: this.isHide('021'),
              field: 'ownerStatus.Owner',
              width: 200,
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'ownerStatus.Owner',
                className: ''
              },
            },
            {
              headerName: 'ՀՎՀՀ',
              id: '022',
              hide: this.isHide('022'),
              field: 'ownerStatus.Notes',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'ownerStatus.Notes',
                className: ''
              },
              width: 130,
            },
            // {
            //   id: '023',
            //   hide: this.isHide('023'),
            //   headerName: 'Հեռախոս(ՃՈ)',
            //   field: 'mobile',
            //   filter: true,
            //   floatingFilterComponent: 'customFloatingFilter',
            //   floatingFilterComponentParams: {
            //     suppressFilterButton: true,
            //     field: 'mobile',
            //     className: ''
            //   },
            //   width: 130,
            // },
            {
              headerName: 'Մարզ',
              id: '024',
              hide: this.isHide('024'),
              field: 'region',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'region',
                className: ''
              },
              width: 180,
            },
            {
              headerName: 'Քաղաք',
              id: '025',
              hide: this.isHide('025'),
              field: 'county',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'county',
                className: ''
              },
              width: 180,
            },
            {
              headerName: 'Փողոց',
              id: '026',
              hide: this.isHide('026'),
              field: 'street',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'street',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'Հասցե',
              id: '027',
              hide: this.isHide('027'),
              field: 'address',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'address',
                className: ''
              },
              width: 150,
            },
            {
              headerName: 'Գրանցման փաստաթուղթ',
              id: '028',
              hide: this.isHide('028'),
              field: 'documentNumber',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'documentNumber',
                className: 'text-uppercase'
              },
              width: 210,
              valueFormatter: this.uppercaseFormatter
            },
          ]
        },
        {
          headerName: 'Տրանսպորտային միջոց',
          id: '03',
          children: [
            {
              headerName: 'Խումբ',
              id: '031',
              hide: this.isHide('031'),
              field: 'car_group',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'car_group',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'Տեսակ',
              id: '032',
              hide: this.isHide('032'),
              field: 'car_type',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'car_type',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'Մեքենա',
              id: '033',
              hide: this.isHide('033'),
              field: 'car',
              valueFormatter: this.carFormatter,
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'car',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'Մակնիշ',
              id: '034',
              hide: this.isHide('034'),
              field: 'car',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'car',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'Մոդել',
              id: '035',
              hide: this.isHide('035'),
              field: 'car_model',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'car_model',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'Թողարկման տարեթիվ',
              id: '036',
              hide: this.isHide('036'),
              field: 'MadeAt',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'MadeAt',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'Գրանցման համարանիշ',
              id: '037',
              hide: this.isHide('037'),
              field: 'CarRegNo',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'CarRegNo',
                className: 'text-uppercase'
              },
              width: 210,
              valueFormatter: this.carRegNoFormatter
            },
            {
              headerName: 'Վառելիքի տեսակ',
              id: '038',
              hide: this.isHide('038'),
              field: 'fuel',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'fuel',
                className: ''
              },
              width: 210,
            },
            // {
            //   headerName: 'Թափքի տեսակ',
            //   field: 'body',
            //   filter: false,
            //   floatingFilterComponent: 'customFloatingFilter',
            //   floatingFilterComponentParams: {
            //     suppressFilterButton: true,
            //     field: 'body',
            //     className: ''
            //   },
            //   width: 210,
            //   valueFormatter: this.bodyNameFormatter,
            // },
            // {
            //   headerName: 'Գույն',
            //   field: 'color',
            //   filter: false,
            //   floatingFilterComponent: 'customFloatingFilter',
            //   floatingFilterComponentParams: {
            //     suppressFilterButton: true,
            //     field: 'color',
            //     className: ''
            //   },
            //   width: 210,
            // },
            {
              headerName: 'Նույնացման (VIN) համարը',
              id: '0392',
              hide: this.isHide('0392'),
              field: 'VIN',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'VIN',
                className: 'text-uppercase'
              },
              width: 210,
            },
            // {
            //   headerName: 'Շարժիչի համար',
            //   field: 'EngineNo',
            //   filter: false,
            //   floatingFilterComponent: 'customFloatingFilter',
            //   floatingFilterComponentParams: {
            //     suppressFilterButton: true,
            //     field: 'EngineNo',
            //     className: ''
            //   },
            //   width: 210,
            // },
            // {
            //   headerName: 'Հենասարքի համար',
            //   field: 'TrilerNo',
            //   filter: false,
            //   floatingFilterComponent: 'customFloatingFilter',
            //   floatingFilterComponentParams: {
            //     suppressFilterButton: true,
            //     field: 'TrilerNo',
            //     className: ''
            //   },
            //   width: 210,
            // },
            // {
            //   headerName: 'Թափքի համար',
            //   field: 'BodyNo',
            //   filter: false,
            //   floatingFilterComponent: 'customFloatingFilter',
            //   floatingFilterComponentParams: {
            //     suppressFilterButton: true,
            //     field: 'BodyNo',
            //     className: ''
            //   },
            //   width: 210,
            // },
            // {
            //   headerName: 'Գազ․ վեր․ ակտ N',
            //   field: 'GasNo',
            //   filter: false,
            //   floatingFilterComponent: 'customFloatingFilter',
            //   floatingFilterComponentParams: {
            //     suppressFilterButton: true,
            //     field: 'GasNo',
            //     className: ''
            //   },
            //   width: 210,
            // },
            {
              headerName: 'Տրված է',
              id: '0397',
              hide: this.isHide('0397'),
              field: 'GasDate',
              filter: true,
              floatingFilterComponent: 'customDateFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'GasDate',
                className: ''
              },
              width: 210,
              valueFormatter: this.dayFormatter
            },
          ]
        },
        {
          headerName: 'Կառուցվածքային փոփոխություն',
          id: '04',
          children: [
            {
              headerName: 'Առկա է',
              id: '041',
              hide: this.isHide('041'),
              field: 'Changes',
              filter: true,
              floatingFilterComponent: 'customSelectFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'Changes',
                className: '',
                options: [
                  {
                    value: true,
                    label: 'Առկա է'
                  },
                  {
                    value: false,
                    label: 'Առկա չէ'
                  }
                ]
              },
              width: 115,
              cellRendererFramework: 'CellRendererChanges'
            },
            {
              headerName: 'Փոփոխություն',
              id: '042',
              hide: this.isHide('042'),
              field: 'ChangesNotes',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'ChangesNotes',
                className: ''
              },
              width: 210,
            },
          ]
        },
        {
          headerName: 'Տեխնիկական զննություն',
          id: '05',
          children: [
            {
              headerName: 'Կտրոնի համար',
              id: '051',
              hide: this.isHide('051'),
              field: 'CheckNo',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'CheckNo',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'Նշումներ',
              id: '052',
              hide: this.isHide('052'),
              field: 'CheckNotes',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'CheckNotes',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'ՏԶ կտրոնի տրման ամսաթիվ',
              id: '053',
              hide: this.isHide('053'),
              field: 'EkoDate',
              filter: true,
              floatingFilterComponent: 'customDateFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'EkoDate',
                className: ''
              },
              width: 210,
              valueFormatter: this.dayFormatter
            },
            {
              headerName: 'Եզրակացություն',
              id: '054',
              hide: this.isHide('054'),
              field: 'Opinion',
              filter: true,
              floatingFilterComponent: 'customSelectFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'Opinion',
                className: '',
                options: [
                  {
                    value: true,
                    label: 'Սարքին'
                  },
                  {
                    value: false,
                    label: 'Անսարք'
                  }
                ]
              },
              width: 180,
              cellRendererFramework: 'CellRendererOpinion'
            },
            {
              headerName: 'Պատճառը',
              id: '055',
              hide: this.isHide('055'),
              field: 'OpinionNotes',
              filter: true,
              floatingFilterComponent: 'customFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'OpinionNotes',
                className: ''
              },
              width: 210,
            },
            {
              headerName: 'Հաջորդ Տ․Զ․',
              id: '056',
              hide: this.isHide('056'),
              field: 'NextCheckup',
              filter: true,
              floatingFilterComponent: 'customSelectFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'NextCheckup',
                className: '',
                options: [
                  {
                    value: 0,
                    label: '6 ամսից'
                  },
                  {
                    value: 1,
                    label: '1 տարուց'
                  },
                  {
                    value: 2,
                    label: '2 տարուց'
                  }
                ]
              },
              width: 160,
              valueFormatter: this.nextCheckupFormatter
            },
            {
              headerName: 'Տաքսի',
              field: 'isTaxi',
              filter: true,
              floatingFilterComponent: 'customSelectFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'isTaxi',
                className: '',
                options: [
                  {
                    value: true,
                    label: 'Այո'
                  },
                  {
                    value: false,
                    label: 'Ոչ'
                  }
                ]
              },
              width: 180,
              cellRendererFramework: 'CellRendererTaxi'
            },
            {
              headerName: 'Կրկնակի Տ․Զ․',
              id: '057',
              hide: this.isHide('057'),
              field: 'DoubleChecked',
              filter: true,
              floatingFilterComponent: 'customSelectFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
                field: 'DoubleChecked',
                className: '',
                options: [
                  {
                    value: true,
                    label: 'Այո'
                  },
                  {
                    value: false,
                    label: 'Ոչ'
                  },
                ]
              },
              width: 150,
              cellRendererFramework: 'CellRendererChanges'
            },
          ]
        },
        // {
        //   headerName: 'Վճարումներ',
        //   id: '06',
        //   children: [
        //     // {
        //     //   headerName: 'Բն․ անդ․ N',
        //     //   field: 'EkoNo',
        //     //   filter: false,
        //     //   floatingFilterComponent: 'customFloatingFilter',
        //     //   floatingFilterComponentParams: {
        //     //     suppressFilterButton: true,
        //     //     field: 'EkoNo',
        //     //     className: ''
        //     //   },
        //     //   width: 210,
        //     // },
        //     {
        //       headerName: 'Գումար',
        //       id: '062',
        //       hide: this.isHide('062'),
        //       field: 'EkoSum',
        //       filter: true,
        //       floatingFilterComponent: 'customFloatingFilter',
        //       floatingFilterComponentParams: {
        //         suppressFilterButton: true,
        //         field: 'EkoSum',
        //         className: ''
        //       },
        //       width: 210,
        //     },
        //     {
        //       headerName: 'Տ․Զ․ վճար',
        //       id: '063',
        //       hide: this.isHide('063'),
        //       field: 'Sum',
        //       filter: true,
        //       floatingFilterComponent: 'customFloatingFilter',
        //       floatingFilterComponentParams: {
        //         suppressFilterButton: true,
        //         field: 'Sum',
        //         className: ''
        //       },
        //       width: 210,
        //     }
        //   ]
        // }
      ]
    },

    user() {
      return authService.user()
    },

    company_operators() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].company_operators.map(e => ({
        label: e.name,
        value: e._id,
      }))
    },

    classificators() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].classificators.map(e => ({
        label: e.name,
        value: e.code,
      }))
    },

    all_classificators() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].all_classificators;
    },

    edit() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].edit
    },

    bodies() {
      return this.$store.state[this.CARS_STORE_MODULE_NAME].bodies
    },

    docs() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].docs
    },

    checkups() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].checkups
    },

    export_checkups() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].export_checkups
    },

    pagination() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].pagination
    },

    filters: {
      get() {
        return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].filters
      },
      set(data) {
        this.$store.commit(this.TECH_SERVICE_STORE_MODULE_NAME + '/SET_INITIAL_FILTERS', data)
      }
    },

    table_class() {
      return (this.isDark) ? 'tech-service-table ag-theme-alpine-dark w-100 ag-grid-table' : 'tech-service-table ag-theme-alpine w-100 ag-grid-table'
    },

    localization() {
      return AG_GRID_LOCALE_HY
    },

    companies() {
      const companies = [...this.$store.state[this.COMPANIES_STORE_MODULE_NAME].companies]
          .sort((a, b) => a.name.localeCompare(b.name)) // sort by name
          .map(e => ({
            label: e.name,
            id: e._id
          }));

      if (this.$device.isMobile) {
        return companies;
      }

      return [
        {
          label: 'Կազմակերպություն',
          value: null,
          disabled: true
        },
        ...companies
      ];
    },

    ownerStatuses() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].ownerStatuses
    },

    nextCheckups() {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].nextCheckups
    },

  },

  beforeMount() {
    this.components = {
      customFloatingFilter: this.getCustomFloatingFilterComponent(),
      customDateFloatingFilter: this.getCustomDateFloatingFilterComponent(),
      customSelectFloatingFilter: this.getCustomSelectFloatingFilterComponent(),
    }
  },

  mounted() {
  },

  created() {
    if (!store.hasModule(this.TECH_SERVICE_STORE_MODULE_NAME)) store.registerModule(this.TECH_SERVICE_STORE_MODULE_NAME, techServiceModule)
    if (!store.hasModule(this.COMPANIES_STORE_MODULE_NAME)) store.registerModule(this.COMPANIES_STORE_MODULE_NAME, companyModule)
    if (!store.hasModule(this.CARS_STORE_MODULE_NAME)) store.registerModule(this.CARS_STORE_MODULE_NAME, carsModule)
    if (!store.hasModule(this.LOCATIONS_STORE_MODULE_NAME)) store.registerModule(this.LOCATIONS_STORE_MODULE_NAME, locationsModule)
    this.getCheckups()
    this.getOperators()
    this.getCompanies()
    this.getBodies()
    this.getRegions()
    // this.filters = this.initialFilters
    // this.filters.type = 'CarRegNo'
  },

  destroyed() {
    this.filters = this.initialFilters
  },

  methods: {

    getRemovedItemsIncluded () {
      this.onlyRemoved = !this.onlyRemoved;
      if (this.onlyRemoved) {
        this.filters.deleted = true;
      } else {
        delete this.filters.deleted;
      }
      this.getCheckups()
    },

    getRemovedItemsNotIncluded () {
      this.withoutRemoved = !this.withoutRemoved;
      if (this.withoutRemoved) {
        this.filters.deleted = false;
      } else {
        delete this.filters.deleted;
      }
      this.getCheckups()
    },

    getTaxDebtItems () {
      if (!this.filters.taxDebt) {
        this.filters.taxDebt = true;
      } else {
        delete this.filters.taxDebt;
      }
      this.getCheckups()
    },

    getNextChanged () {
      if (!this.filters.nextCheckupChanged) {
        this.filters.nextCheckupChanged = true;
      } else {
        delete this.filters.nextCheckupChanged;
      }
      this.getCheckups()
    },

    getNotAutoDetectedItemsItems () {
      if (typeof this.filters.autoDetection === "undefined") {
        this.filters.autoDetection = false;
      } else {
        delete this.filters.autoDetection;
      }
      this.getCheckups()
    },

    changeSearchTypeMobile(id) {
      this.filters.type = id
      this.getCheckups()
    },

    getOperators() {
      this.$store.dispatch(this.TECH_SERVICE_STORE_MODULE_NAME + '/getOperators')
      this.$store.dispatch(this.TECH_SERVICE_STORE_MODULE_NAME + '/getClassificators')
    },

    getBodies() {
      return this.$store.dispatch(this.CARS_STORE_MODULE_NAME + '/getBodies')
    },

    getCompanies() {
      this.$store.dispatch(this.COMPANIES_STORE_MODULE_NAME + '/getViewerCompanies')
    },

    onGridReady(params) {
      this.$store.commit(this.TECH_SERVICE_STORE_MODULE_NAME + '/SET_GRID_API', params.api)
      this.$store.commit(this.TECH_SERVICE_STORE_MODULE_NAME + '/SET_GRID_COLUMN_API', params.columnApi)
    },

    getCheckups() {
      this.$vs.loading()
      const filters = JSON.parse(JSON.stringify(this.filters))
      const { fields } = filters
      delete filters.fields
      filters.columnFilter = JSON.stringify(fields)
      const filterData = {
        current_page: this.pagination.current_page,
        ...filters
      }
      this.$store.dispatch(this.TECH_SERVICE_STORE_MODULE_NAME + '/getViewerCheckups', this.serialize(filterData))
          .then(() => {
            this.$vs.loading.close()
          })
          .catch((error) => {
            this.$root.$emit('getError', error)
            this.$vs.loading.close()
          })
    },

    serialize(obj) {
      let str = []
      for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
          if (typeof obj[p] !== 'undefined' && obj[p] !== null && obj[p] !== '') {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
          }
        }
      }
      return str.join('&')
    },

    changePage(page) {
      this.pagination.current_page = page
      this.getCheckups()
    },

    disableSymbol(e) {
      if (!(/^[*a-zA-Z0-9ղցվա]*$/.test(e.key))) {
        e.preventDefault()
      }
    },

    changeCompany() {
      this.getCheckups()
    },

    searchCheckup() {
      this.getCheckups()
    },

    ownerStatusFormatter(params) {
      const index = this.ownerStatuses.findIndex((i) => i.id === params.value)
      if (index >= 0) {
        return this.ownerStatuses[index].title
      }
      return ''
    },

    companyAddressFormatter(params) {
      return params.value.region + ' ' + params.value.county + ' ' + params.value.street + ' ' + params.value.address
    },

    carFormatter(params) {
      return params.data.car + ' ' + params.data.car_model
    },

    classificatorFormatter(params) {
      const names = [...new Set(
          params.data.classificators.map(id => {
            const item = this.all_classificators.find(e => e.id === id);
            const parentCode = item ? Math.floor(item.code / 100) * 100 : null;
            return this.all_classificators.find(e => e.code === parentCode)?.name;
          }).filter(Boolean)
      )];
      return names.join(', ');
    },

    carRegNoFormatter({ data }) {
      const { CarRegNo, YellowCarRegNo, autoDetection } = data
      const yellow = YellowCarRegNo ? ` (${YellowCarRegNo.toUpperCase()})` : ''
      return `${autoDetection ? '✅' : '❌'} ${CarRegNo}${yellow}`
    },

    bodyNameFormatter(params) {
      if (params.value) {
        return params.value
      } else {
        let bodyIndex = this.bodies.findIndex((b) => b.id === params.data.body_id)
        if (bodyIndex >= 0) {
          return this.bodies[bodyIndex].name
        }
      }
    },

    uppercaseFormatter(params) {
      return (params.value) ? params.value.toLocaleUpperCase() : params.value
    },

    dateFormatter(params) {
      return this.$options.filters.formatDate(params.value)
    },

    dayFormatter(params) {
      return this.$options.filters.formatDay(params.value)
    },

    nextCheckupFormatter(params) {
      const index = this.nextCheckups.findIndex((e) => e.value == params.value)
      if (index >= 0) {
        return this.nextCheckups[index].label
      }
      return params.value
    },

    nextCheckupName(value) {
      const index = this.nextCheckups.findIndex((e) => e.value == value)
      if (index >= 0) {
        return this.nextCheckups[index].label
      }
      return value
    },

    appendFilter(field, value) {
      this.filters.fields[field] = value
      this.getCheckups()
    },

    appendDateFilter(field, value) {
      let start = new Date(value)
      start.setHours(0, 0, 0, 0)
      let end = new Date(value)
      end.setHours(23, 59, 59, 59)
      if (field === 'createdAt') {
        this.filters.startDate = start
        this.filters.endDate = end
      }
      this.getCheckups()
    },

    getCustomFloatingFilterComponent() {
      const methods = this

      function NumberFloatingFilter() {
      }

      NumberFloatingFilter.prototype.init = function (params) {
        this.eGui = document.createElement('div')
        this.eGui.innerHTML = '<input class="ag-input-field-input ag-text-field-input ' + params.className + '" type="text" />'
        this.currentValue = null
        this.eFilterInput = this.eGui.querySelector('input')
        const that = this
        const onInputBoxChanged = () => {
          that.currentValue = that.eFilterInput.value
          methods.appendFilter(params.field, that.currentValue)
        }
        this.eFilterInput.addEventListener('change', onInputBoxChanged)
      }
      NumberFloatingFilter.prototype.onParentModelChanged = function (parentModel) {
        if (!parentModel) {
          this.eFilterInput.value = ''
          this.currentValue = null
        } else {
          this.eFilterInput.value = parentModel.filter + ''
          this.currentValue = parentModel.filter
        }
      }
      NumberFloatingFilter.prototype.getGui = function () {
        return this.eGui
      }
      return NumberFloatingFilter
    },

    getCustomSelectFloatingFilterComponent() {
      const methods = this

      function NumberFloatingFilter() {
      }

      NumberFloatingFilter.prototype.init = function (params) {
        this.eGui = document.createElement('div')
        let select = '<select class="ag-input-field-input ag-text-field-input ' + params.className + '">'
        select += '<option value=""></option>'
        if (params.options && params.options.length > 0) {
          params.options.map((item) => {
            select += `<option value="${item.value}">${item.label}</option>`
          })
        }
        select += '</select>'
        this.eGui.innerHTML = select
        this.currentValue = null
        this.eFilterInput = this.eGui.querySelector('select')
        const that = this
        const onInputBoxChanged = () => {
          that.currentValue = that.eFilterInput.value
          methods.appendFilter(params.field, that.currentValue)
        }
        this.eFilterInput.addEventListener('change', onInputBoxChanged)
      }
      NumberFloatingFilter.prototype.onParentModelChanged = function (parentModel) {
        if (!parentModel) {
          this.eFilterInput.value = ''
          this.currentValue = null
        } else {
          this.eFilterInput.value = parentModel.filter + ''
          this.currentValue = parentModel.filter
        }
      }
      NumberFloatingFilter.prototype.getGui = function () {
        return this.eGui
      }
      return NumberFloatingFilter
    },

    getCustomDateFloatingFilterComponent() {
      const methods = this

      function NumberFloatingFilter() {
      }

      NumberFloatingFilter.prototype.init = function (params) {
        this.eGui = document.createElement('div')
        this.eGui.className = 'w-100'
        this.eGui.innerHTML = '<input data-date-format="DD/MM/YYYY" class="ag-input-field-input ag-text-field-input ' + params.className + '" type="date" />'
        this.currentValue = null
        this.eFilterInput = this.eGui.querySelector('input')
        const that = this
        const onInputBoxChanged = () => {
          that.currentValue = that.eFilterInput.value
          methods.appendDateFilter(params.field, that.currentValue)
        }
        this.eFilterInput.addEventListener('change', onInputBoxChanged)
      }
      NumberFloatingFilter.prototype.onParentModelChanged = function (parentModel) {
        if (!parentModel) {
          this.eFilterInput.value = ''
          this.currentValue = null
        } else {
          this.eFilterInput.value = parentModel.filter + ''
          this.currentValue = parentModel.filter
        }
      }
      NumberFloatingFilter.prototype.getGui = function () {
        return this.eGui
      }
      return NumberFloatingFilter
    },

    getRegions() {
      this.$store.dispatch(`${this.LOCATIONS_STORE_MODULE_NAME}/getRegions`)
    },

  }

}

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#tech-service-all {

  //.ag-header {
  //  min-height: inherit !important;
  //
  //  .ag-header-row-floating-filter {
  //    display: none !important;
  //  }
  //
  //}


  .tech-service-table {
    max-height: calc(var(--vh, 1vh) * 100 - 13rem);
    min-height: calc(var(--vh, 1vh) * 100 - 13rem);
    height: calc(var(--vh, 1vh) * 100 - 13rem);
    padding: 0.5rem;
  }

  .table-footer {
    padding-bottom: 10px !important;
  }
}
</style>
<style lang="scss" scoped>
@media (max-width: 768px) {
  [dir=ltr] .col-xl, [dir=ltr] .col-xl-auto, [dir=ltr] .col-xl-12, [dir=ltr] .col-xl-11, [dir=ltr] .col-xl-10, [dir=ltr] .col-xl-9, [dir=ltr] .col-xl-8, [dir=ltr] .col-xl-7, [dir=ltr] .col-xl-6, [dir=ltr] .col-xl-5, [dir=ltr] .col-xl-4, [dir=ltr] .col-xl-3, [dir=ltr] .col-xl-2, [dir=ltr] .col-xl-1, [dir=ltr] .col-lg, [dir=ltr] .col-lg-auto, [dir=ltr] .col-lg-12, [dir=ltr] .col-lg-11, [dir=ltr] .col-lg-10, [dir=ltr] .col-lg-9, [dir=ltr] .col-lg-8, [dir=ltr] .col-lg-7, [dir=ltr] .col-lg-6, [dir=ltr] .col-lg-5, [dir=ltr] .col-lg-4, [dir=ltr] .col-lg-3, [dir=ltr] .col-lg-2, [dir=ltr] .col-lg-1, [dir=ltr] .col-md, [dir=ltr] .col-md-auto, [dir=ltr] .col-md-12, [dir=ltr] .col-md-11, [dir=ltr] .col-md-10, [dir=ltr] .col-md-9, [dir=ltr] .col-md-8, [dir=ltr] .col-md-7, [dir=ltr] .col-md-6, [dir=ltr] .col-md-5, [dir=ltr] .col-md-4, [dir=ltr] .col-md-3, [dir=ltr] .col-md-2, [dir=ltr] .col-md-1, [dir=ltr] .col-sm, [dir=ltr] .col-sm-auto, [dir=ltr] .col-sm-12, [dir=ltr] .col-sm-11, [dir=ltr] .col-sm-10, [dir=ltr] .col-sm-9, [dir=ltr] .col-sm-8, [dir=ltr] .col-sm-7, [dir=ltr] .col-sm-6, [dir=ltr] .col-sm-5, [dir=ltr] .col-sm-4, [dir=ltr] .col-sm-3, [dir=ltr] .col-sm-2, [dir=ltr] .col-sm-1, [dir=ltr] .col, [dir=ltr] .col-auto, [dir=ltr] .col-12, [dir=ltr] .col-11, [dir=ltr] .col-10, [dir=ltr] .col-9, [dir=ltr] .col-8, [dir=ltr] .col-7, [dir=ltr] .col-6, [dir=ltr] .col-5, [dir=ltr] .col-4, [dir=ltr] .col-3, [dir=ltr] .col-2, [dir=ltr] .col-1 {
    padding-right: 0;
    padding-left: 0;
  }
}
.companyInfo {
  display: flex;
  flex-direction: column;
  .infoItem {
    display: flex;
    justify-content: flex-start;
    flex-flow: row;
    margin-bottom: 15px;
    .label {
      width: 50%;
    }
    .value {
      width: 50%;
      color: #000;
      font-weight: bold;
      font-size: 0.9rem;
    }
  }
}
</style>
<style lang="scss">
.badgeColView {
  width: 55%!important;
}
.double-checkup {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  padding: 0 13px;
  cursor: pointer;
  height: 100%;

  &.active {
    background: #2e2e2e;
    color: #fff;
  }
}
.double-checkup {
  padding: 0 23px;
  cursor: pointer;
  background: #E9EDF6;
  color: #164866;
  border-radius: 26px;
  font-weight: bold;
}
.auto-detected-checkup {
  background: red;
  color: #fff;
  &.active {
    background: #767676;
  }
}
.filters .filter-column .opinionFilter {
  width: 200px !important;
}
.createdDate {
  position: absolute;
  top: 20px;
  right: 30px;
  background: rgb(0 0 0 / 67%);
  padding: 5px 5px;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  border-radius: 7px;
}
.detectedCarRegNoModalInfo {
  position: absolute;
  top: 65px;
  right: 30px;
  background: rgb(0 0 0 / 67%);
  padding: 5px 5px;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  border-radius: 7px;
}
</style>